module.exports = __webpack_public_path__ + "img/activate-health.b61a0444.png";